import { ShopifySectionService } from './shopify-section.service.js'
import type { ShopifyTheme } from '../types/index.js'

/**
 * @see https://shopify.dev/api/section-rendering
 */
export class ShopifyThemeService {
  static root = window.Shopify?.routes?.root || '/'

  /** Get the id, name and role of the current active theme */
  static async getTheme(): Promise<ShopifyTheme | null> {
    const html = await ShopifySectionService.getSection('utils-json-theme')

    // Remove html div tags
    const jsonStr = html.replace(/<\/?div.*?>/gm, '').trim()

    try {
      return JSON.parse(jsonStr)
    } catch (error) {
      console.warn("Can't parse theme data: ", error)
      console.warn(`The JSON string tried to parse is: "${jsonStr}"`)
      return null
    }
  }
}
